<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <div>
            <table>
                <tr>
                    <td>{{$t('getapi[1981]')}}</td>
                    <td style="width:120px;">
                        <el-select filterable v-model="queryData.cbmtype" size="mini">
                            <el-option key="1" :label="$t('getapi[1167]')" value='1'></el-option>
                            <el-option key="2" :label="$t('getapi[1507]')" value='2'></el-option>
                            <el-option key="3" :label="$t('getapi[4564]')" value='3'></el-option>
                        </el-select>
                    </td>
                    <td style="width:30px">{{$t('getapi[1979]')}}</td>
                    <td style="width:120px;">
                        <el-select filterable v-model="queryData.cbmppvType" size="mini">
                            <el-option key="1" :label="$t('getapi[1983]')" value='1'></el-option>
                            <el-option key="2" :label="$t('getapi[1984]')" value='2'></el-option>
                        </el-select>
                    </td>
                    <td style="width:30px">{{$t('getapi[1964]')}}</td>
                    <td style="width:100px;">
                        <el-input type="text" size="mini" v-model="queryData.tyear"></el-input>
                    </td>
                    <td style="width:30px">{{$t('getapi[1975]')}}</td>
                    <td style="width:100px;">
                        <el-input type="text" size="mini" v-model="queryData.tmonth"></el-input>
                    </td>
                    <td>
                        <el-button type="primary" size="mini" @click="getView()">{{$t('getapi[1980]')}}</el-button>
                    </td>
                </tr>
            </table>
        </div>
        <div id="xpane-0">
        <vxe-table :data="dataSet.dt" size="mini" :loading="loading" :height="tableHeight" stripe border resizable
                   ref="singleTable">
            <vxe-table-column show-footer-overflow v-for="item in dataSet.header"
                              :key="item.Headen"
                              :field="item.Headen"
                              :title="item.Headcn"
                              :align="item.Headen =='PPV'?'right':'left'"
                              width="150px"
            >
                <template scope="scope" >
                    <span v-if="item.Headen =='PPV'">{{ scope.row[item.Headen] | thousandth}}</span>
                    <span v-else>{{ scope.row[item.Headen]}}</span>
                </template>
            </vxe-table-column>
        </vxe-table>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'buyerppv',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                dataSet: {
                    header: [],
                    dt: []
                }, // 主表数据
                queryData: {
                    cbmtype: '1',
                    cbmppvType: '1',
                    tyear: '',
                    tmonth: ''
                }, // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[969]"),this.$t("getapi[16]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (that.$limits.authority('plv2', 72, 1) == 1) {
                    that.$refs.SetBtn.SetButtonEnable('refresh,export');
                }
                if (that.$limits.authority('plv2', 72, 1) == 2) {
                    that.$refs.SetBtn.SetButtonEnable('refresh,export');
                }
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = that.queryData
                that.$http.urlpost('/Pur/Statistics/GetBuyerPPVDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let parm = that.queryData
                that.$http.urlpost('/Pur/Statistics/GetBuyerPPVToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
